function showProductPhoto(source, alt) {
  const image = document.querySelector('#detail-image');
  if (!image || !source) return;
  image.removeAttribute('srcset');
  image.src = source;
  if (alt) image.alt = alt;
  document.querySelectorAll('[data-photo]').forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.photo === source));
  });
  const photos = [...document.querySelectorAll('.thumbs [data-photo]')];
  const index = photos.findIndex(button => button.dataset.photo === source);
  const count = document.querySelector('[data-gallery-count]');
  if (count) count.textContent = (index + 1) + ' / ' + photos.length;
}
document.querySelectorAll('[data-photo]').forEach(button => {
  const image = document.querySelector('#detail-image');
  button.setAttribute('aria-pressed', String(button.dataset.photo === image?.getAttribute('src')));
  button.addEventListener('click', () => showProductPhoto(button.dataset.photo, button.querySelector('img')?.alt));
});
const variant = document.querySelector('#variant');
variant?.addEventListener('change', () => {
  const selected = variant.selectedOptions[0];
  if (!selected) return;
  const button = document.querySelector('#product-submit');
  if (button) {
    button.disabled = selected.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
  }
  const price = document.querySelector('#product-price');
  if (price) price.textContent = selected.dataset.price;
  if (selected.dataset.photo) showProductPhoto(selected.dataset.photo, document.querySelector('.detail-copy h1')?.textContent.trim());
  const url = new URL(location.href);
  url.searchParams.set('variant', selected.value);
  history.replaceState(null, '', url);
});
const filterButtons = document.querySelectorAll('[data-filter]');
function filter(category) {
  filterButtons.forEach(button => {
    button.classList.toggle('active', button.dataset.filter === category);
    button.setAttribute('aria-pressed', String(button.dataset.filter === category));
  });
  let count = 0;
  document.querySelectorAll('#collection-grid [data-category]').forEach(card => {
    card.hidden = category !== 'All' && category !== card.dataset.category;
    if (!card.hidden) count++;
  });
  const counter = document.querySelector('#collection-count');
  if (counter) counter.textContent = count + (count === 1 ? ' piece' : ' pieces');
  const empty = document.querySelector('#filter-empty');
  if (empty) empty.hidden = count > 0;
}
filterButtons.forEach(button => button.addEventListener('click', () => {
  filter(button.dataset.filter);
  const url = new URL(location.href);
  if (button.dataset.filter === 'All') url.searchParams.delete('category');
  else url.searchParams.set('category', button.dataset.filter);
  history.replaceState(null, '', url);
}));
const category = new URLSearchParams(location.search).get('category');
if (category && [...filterButtons].some(button => button.dataset.filter === category)) filter(category);

const galleryPhotos = [...document.querySelectorAll('.thumbs [data-photo]')];
function stepProductPhoto(direction) {
  if (!galleryPhotos.length) return;
  let current = galleryPhotos.findIndex(button => button.getAttribute('aria-pressed') === 'true');
  const next = galleryPhotos[(Math.max(0, current) + direction + galleryPhotos.length) % galleryPhotos.length];
  showProductPhoto(next.dataset.photo, next.querySelector('img')?.alt);
  next.scrollIntoView({block:'nearest',inline:'nearest'});
}
document.querySelector('[data-gallery-prev]')?.addEventListener('click', () => stepProductPhoto(-1));
document.querySelector('[data-gallery-next]')?.addEventListener('click', () => stepProductPhoto(1));
const galleryImage = document.querySelector('#detail-image');
let galleryTouch = null;
galleryImage?.addEventListener('touchstart', event => {
  galleryTouch = {x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY};
}, {passive:true});
galleryImage?.addEventListener('touchend', event => {
  if (!galleryTouch) return;
  const dx = event.changedTouches[0].clientX - galleryTouch.x;
  const dy = event.changedTouches[0].clientY - galleryTouch.y;
  if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)*1.5) stepProductPhoto(dx < 0 ? 1 : -1);
  galleryTouch = null;
}, {passive:true});
if (galleryImage) showProductPhoto(galleryImage.getAttribute('src'), galleryImage.alt);

document.querySelectorAll('.thumbs [data-photo]').forEach((button,index)=>{button.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%galleryPhotos.length;else if(event.key==='ArrowLeft')next=(index-1+galleryPhotos.length)%galleryPhotos.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=galleryPhotos.length-1;else return;event.preventDefault();galleryPhotos[next].focus();galleryPhotos[next].click();});});
